export function normalizeSlotLocationSelection(value: { location?: string; locations?: string[] }) {
  const explicitLocations = Array.isArray(value.locations)
    ? value.locations.filter((item): item is string => typeof item === 'string' && Boolean(item.trim()))
    : [];

  const fallbackLocation = typeof value.location === 'string' && value.location.trim() ? value.location : '';
  const normalizedLocations = explicitLocations.length > 0 ? explicitLocations : fallbackLocation ? [fallbackLocation] : [];

  return {
    location: normalizedLocations[0] ?? fallbackLocation,
    locations: normalizedLocations,
  };
}

export function buildSlotCreateTemplate(slot: Record<string, any> | null | undefined) {
  if (!slot) return undefined;

  const code = typeof slot.code === 'string' ? slot.code : Array.isArray(slot.codes) ? slot.codes[0] ?? '' : '';
  const { location, locations } = normalizeSlotLocationSelection({
    location: slot.location,
    locations: slot.locations,
  });

  return {
    ...slot,
    id: '',
    code,
    codes: code ? [code] : [],
    defaultTeacher: slot.defaultTeacher ?? '',
    day: slot.day ?? '',
    time: slot.time ?? '',
    duration: slot.duration ?? 0,
    location,
    locations,
    room: slot.room ?? '',
    hidden: Boolean(slot.hidden),
    started: false,
  };
}
